import {call, put, select} from "redux-saga/effects";
import {toast} from "react-toastify";
import {setLoading as setDynamicLoading} from "../../slices/dynamicElementsSlice";
import {
  deleteFeature,
  getAdminFeatures, getAdminPermissions, postOrPutAdminFeatures, postPermissionsToFeatures
} from "../requests/userService";
import {setFeatures, setManageFeatureModals, setPermissions} from "../../slices/permissionSlice";

export function* handleGetAllFeatures() {
  try {

    yield put(setFeatures({loading: true}));

    const {
      data
    } = yield call(() => getAdminFeatures());


    yield put(setFeatures({data}));

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    yield put(setFeatures({error: errorMsg}));
  }
}

export function* handleGetAllPermissions() {
  try {

    yield put(setPermissions({loading: true}));

    const {
      data
    } = yield call(() => getAdminPermissions());

    yield put(setPermissions({data}));

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    yield put(setPermissions({error: errorMsg}));
  }
}

export function* handleAddOrUpdateFeature(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: isEdit} = yield select((state) => state.permission.modals.form);
    const {data} = yield call(() => postOrPutAdminFeatures(isEdit?.id, action.payload));

    if (isEdit) {
      yield put(setFeatures({update: data}));
      toast.success('Feature Updated Successfully.');
    } else {
      yield put(setFeatures({create: data}));
      toast.success('Feature Added Successfully.');
    }
    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageFeatureModals());

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleUpdateFeaturesPermissions(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: feature} = yield select((state) => state.permission.modals.permission);


    const {data} = yield call(() => postPermissionsToFeatures(feature.id, action.payload.permissions.map((p) => p.id)));

    yield put(setFeatures({update: data}));
    toast.success('Updated Permissions Successfully.');


    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageFeatureModals());

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleDeleteFeature() {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: {feature, remove}} = yield select((state) => state.permission.modals.confirm);

    if (remove) {
      const {data} = yield call(() => postPermissionsToFeatures(feature.id, feature.permissions.map((p) => p.id).filter((pId) => pId !== remove.id)));
      yield put(setFeatures({update: data}));
      toast.success('Removed permission successfully.');
    } else {
      yield call(() => deleteFeature(feature.id));


      yield put(setFeatures({delete: feature}));
      toast.success('Feature Deleted Successfully.');
    }


    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageFeatureModals());

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}


